import { render, staticRenderFns } from "./MainStats.vue?vue&type=template&id=25cad974&scoped=true&"
import script from "./MainStats.vue?vue&type=script&lang=js&"
export * from "./MainStats.vue?vue&type=script&lang=js&"
import style0 from "./MainStats.vue?vue&type=style&index=0&id=25cad974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cad974",
  null
  
)

export default component.exports